import { createContext, useContext, useState, useEffect } from 'react';
import { AppHelper } from './AppHelper';

const UserContext = createContext();

export const useUser = () => {
  return useContext(UserContext);
};

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(null);

  useEffect(() => {
    if(!user){
      var _user = AppHelper.userCacheGet();
      if(!_user) return;
      setUser(_user);
    }

    return () => {
    };
  }, []);

  const getUser = ()=>{
    var _user = AppHelper.userCacheGet();
    if(!_user) return;
    setUser(_user);
  }

  return (
    <UserContext.Provider value={{user, getUser}}>{children}</UserContext.Provider>
  );
};